import { render, staticRenderFns } from "./LoginStatus.vue?vue&type=template&id=1087e592&scoped=true&"
import script from "./LoginStatus.ts?vue&type=script&lang=ts&"
export * from "./LoginStatus.ts?vue&type=script&lang=ts&"
import style0 from "./LoginStatus.vue?vue&type=style&index=0&id=1087e592&lang=vue-scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087e592",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1087e592')) {
      api.createRecord('1087e592', component.options)
    } else {
      api.reload('1087e592', component.options)
    }
    module.hot.accept("./LoginStatus.vue?vue&type=template&id=1087e592&scoped=true&", function () {
      api.rerender('1087e592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/LoginStatus/Components/LoginStatus.vue"
export default component.exports